import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Media,
} from "reactstrap"
import { Link } from "react-router-dom"
import classNames from "classnames"
//import Charts
import StackedColumnChart from "./StackedColumnChart"

//import action
import { getChartsData as onGetChartsData } from "../../store/actions"

// Pages Components
import WelcomeComp from "./WelcomeComp"
import MonthlyEarning from "./MonthlyEarning"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
//i18n
import { withTranslation } from "react-i18next"
//redux
import { useSelector, useDispatch } from "react-redux"
import { Context } from '../../app-contexts/CommonContexts';
import { useContext } from "react"
import LatestTranaction from "./LatestTranaction"
import TopCities from "./TopCities"
import ActivityComp from "./ActivityComp"
import SocialSource from "./SocialSource"
import Section from "pages/Crypto/CryptoIcoLanding/HeroSection/Section"
import WhatsNew from "framework/components/WhatsNew"
const Dashboard = props => {

  const [subscribemodal, setSubscribemodal] = useState(false)


  const {
    getSetupDetailsContext, cashbokDate
  } = useContext(Context);


  const [permissionToDisplay, setPermissionToDisplay] = useState(
    {
      section1: false,
      section2: false,
      section3: false,
      section4: false,
      section5: false,
      section6: false,
      section7: false,
      section8: false,
    }
  )

  const [dashboardData, setDashboardData] = useState({
    label1: "",
    label1Value: "",
    label2: "",
    label2Value: "",
    label3: "",
    label3Value: "",
    label4: "",
    label4Value: "",
    label5: "",
    label5Value: "",
    label6: "",
    label6Value: "",
    label7: "",
    label7Value: "",
    label8: "",
    label8Value: "",
    label9: "",
    label10: "",
    label12: "",
    label12Value: "",
    label13: "",
    label13Value: "",
    label14: "",
    label14Value: "",

  })

  const reports = [
    { title: dashboardData.label1, iconClass: "bx-copy-alt", description: dashboardData.label1Value, display: permissionToDisplay.section1 },
    { title: dashboardData.label2, iconClass: "bx-archive-in", description: dashboardData.label2Value, display: permissionToDisplay.section2 },
    { title: dashboardData.label3, iconClass: "bx-purchase-tag-alt", description: dashboardData.label3Value, display: permissionToDisplay.section3 },
    { title: dashboardData.label12, iconClass: "bx-copy-alt", description: dashboardData.label12Value, display: permissionToDisplay.section4 },
    { title: dashboardData.label13, iconClass: "bx-archive-in", description: dashboardData.label13Value, display: permissionToDisplay.section5 },
    { title: dashboardData.label14, iconClass: "bx-purchase-tag-alt", description: dashboardData.label14Value, display: permissionToDisplay.section6 },
  ]
  const [periodData, setPeriodData] = useState([{ data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], name: "POS" }, { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], name: "Back Office" }])
  const [periodType, setPeriodType] = useState("yearly")

  useEffect(async () => {
    const obj = JSON.parse(localStorage.getItem("authUser"))

    let userName = obj[2]
    let loccode = obj[3]
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    await fetch(`${ApiURL}dashboard/dash/${userName}/${loccode}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    })
      .then(Response => Response.json())
      .then(responseData => {
        const data = responseData.data
        let posData = responseData.pos
        let bakDdata = responseData.bak
        setDashboardData(responseData.data)
        setPermissionToDisplay(responseData.dashboardPermission)
        setPeriodData([{ data: posData, name: data.label10 }, { data: bakDdata, name: data.label11 }])

      }).catch(error => {
        console.log("Error getting dashboard data", error)
      })


    setTimeout(() => {
      setSubscribemodal(false)
    }, 2000)

    await getSetupDetailsContext()

  }, [])


  const onChangeChartPeriod = pType => {
    setPeriodType(pType)
    dispatch(onGetChartsData(pType))
  }

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(onGetChartsData("yearly"))
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <Row>
            <Col xl="4">
              <WhatsNew />
              <WelcomeComp
                // userInv={userInvCount}
                // userRevenue={userRevenue}
                // currency={currency}
                dashboardData={dashboardData}
              />
              {permissionToDisplay.section7 ? <MonthlyEarning
                // currency={currency}
                // monthEarning={monthEarning}
                // presentage={growthPercentage}
                // archivement={archivement}
                dashboardData={dashboardData}
              /> : null}
            </Col>
            <Col xl="8">
              <Row>
                {/*Reports Render*/}
                {reports.map((report, key) => {
                  if (!report.display) {
                    return null
                  }
                  return (
                    <Col md="4" key={"_col_" + key}>
                      <Card className="mini-stats-wid">
                        <CardBody>
                          <Media>
                            <Media body>
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h5 className="mb-0">{report.description}</h5>
                            </Media>
                            <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i
                                  className={
                                    "bx " + report.iconClass + " font-size-24"
                                  }
                                ></i>
                              </span>
                            </div>
                          </Media>
                        </CardBody>
                      </Card>
                    </Col>
                  )
                }
                )}
              </Row>

              {permissionToDisplay.section8 ? <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">{dashboardData.label9}</h4>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        {/*} <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "weekly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("weekly")
                            }}
                            id="one_month"
                          >
                            Week
                          </Link>{" "}
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "monthly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("monthly")
                            }}
                            id="one_month"
                          >
                            Month
                          </Link>
                        </li>*/}
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "yearly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("yearly")
                            }}
                            id="one_month"
                          >

                            {new Date().getFullYear()}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <StackedColumnChart periodData={periodData} />
                </CardBody>
              </Card> : null}
            </Col>
          </Row>

          {/* <Row>
            <Col xl="4">
              <SocialSource />
            </Col>
            <Col xl="4">
              <ActivityComp />
            </Col>

            <Col xl="4">
              <TopCities />
            </Col>
          </Row> */}

          {/* <Row>
            <Col lg="12">
              <LatestTranaction />
            </Col>
          </Row>  */}
        </Container>
      </div>




    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
